<template>
    <Transition>
        <Teleport to="#modals">
            <Modal
                v-show="active && isDesktop"
                :active="active && isDesktop"
                type="full"
                @close="emits('close')"
            >
                <p
                    v-if="total"
                    class="fixed top-3 left-3 md:top-5 md:left-5 inline-flex items-center gap-2.5 py-2 px-2.5 rounded-sm bg-white text-brand-2-950 font-semibold text-xssss tabular-nums"
                >
                    <span
                        class="size-[18px]"
                        v-html="CameraIcon"
                    ></span>
                    {{ currentSlide }} / {{ total }}
                </p>

                <slot />
            </Modal>
        </Teleport>
    </Transition>
</template>

<script setup>
    import { ref, onMounted, watch } from 'vue';

    import Modal from '@js/src/components/Modal.vue';

    import { useBackToClose } from '@js/src/composables/useBackToClose';

    import CameraIcon from '@img/icons/camera.svg?raw';

    const props = defineProps([
        'active',
        'total',
        'slide',
    ]);

    const emits = defineEmits(['close']);

    const sliderName = 'property-gallery';
    const currentSlide = ref(1);

    // Below 501px the vertical-scroll MobileGalleryOverlay takes over; this
    // carousel only activates on desktop. Gating reloadSlider() (not just the
    // v-show) is what stops Flickity ever loading the carousel cells on mobile.
    // The variant is fixed at open time to stay in lockstep with the overlay.
    const isDesktop = ref(true);

    // Back button dismisses the lightbox instead of navigating off the house page.
    const backToClose = useBackToClose(() => emits('close'));

    watch(() => props.active, (active) => {
        if (!active) {
            // Consumes the pushed history entry on UI-driven (X / backdrop) closes;
            // no-op when a back press already closed us or we never opened (mobile).
            backToClose.close();

            return;
        }

        isDesktop.value = !window.matchMedia('(max-width: 500px)').matches;

        if (isDesktop.value) {
            backToClose.open();
            reloadSlider();
        }
    });

    onMounted(() => {
        window.addEventListener('landedHouses/flickity/change', (e) => {
            if (e.detail.name === sliderName) {
                currentSlide.value = e.detail.index + 1;
            }
        });
    });

    function reloadSlider() {
        const slider = LandedHouses.sliders[sliderName];

        if (slider) {
            slider.select(props.slide, true, true);

            setTimeout(() => {
                slider.reloadCells();
                slider.resize();
            }, 300);
        }
    }
</script>
